<template>
	<div class="p-4 md:p-6 flex-1 overflow-y-auto font-sans">
		<!-- ── Section Header ── -->
		<div
			class="flex items-center justify-between mb-6 pb-5 border-b border-primary-100 dark:border-dark-600">
			<div class="flex items-center gap-3">
				<div
					class="w-10 h-10 rounded-xl bg-primary-50 dark:bg-primary-400/15 flex items-center justify-center flex-shrink-0">
					<svg
						class="w-5 h-5 text-primary-400"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5" />
					</svg>
				</div>
				<div>
					<h1
						class="font-display text-xl md:text-2xl font-extrabold tracking-tight text-dark-700 dark:text-white">
						Organization Management
					</h1>
					<p class="text-[13px] text-muted dark:text-muted-light mt-0.5">
						Manage organizer accounts
					</p>
				</div>
			</div>
		</div>

		<Breadcrumbs />

		<div
			class="bg-surface dark:bg-dark-700 rounded-card shadow-card border border-primary-100 dark:border-dark-600 p-6 transition-colors duration-300">
			<OrganizersList :organizers="OrganizersList" />
		</div>
	</div>
</template>

<script>
import { ref, onMounted } from "vue";
import OrganizersList from "@/components/OrganizersList.vue";
import { apiDataService } from "@/services/apiDataService";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {
	name: "OrganizationList",
	components: { OrganizersList, Breadcrumbs },
	setup() {
		const OrganizersList = ref([]);
		const getOrganizers = async () => {
			try {
				const response = await apiDataService.getOrganizers();
				OrganizersList.value = response.data;
			} catch (error) {
				console.error("Error fetching users:", error);
			}
		};
		onMounted(() => {
			getOrganizers();
		});
		return { OrganizersList };
	},
};
</script>
